module.exports = __webpack_public_path__ + "img/lv5_2_1.6b2eb211.png";